import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/experimental-api/classname-generator/classname-generator.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
